import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { BodyTextTW } from 'tailwindComponents/bodyText/BodyTextTW';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { Spinner } from 'ui-toolkit';
import { DateFormat, getDateString } from '../../../ui-toolkit/utilities/getDateString';

export interface IFundingCompleteProps {
  hasEditPermission?: boolean;
  onCompleteFunding?: () => void;
  isLoading?: boolean;
  fundedAt?: string;
  fundedBy?: string;
}

export const FundingComplete: React.FC<IFundingCompleteProps> = ({
  hasEditPermission = false,
  onCompleteFunding = () => {},
  fundedAt,
  fundedBy,
  isLoading = false,
}) => {
  return (
    <div>
      {isLoading && <Spinner />}
      {!isLoading && !fundedAt && (
        <section>
          {!hasEditPermission && (
            <div data-test-id={'no-permissions'}>
              <FontAwesomeIcon icon={faExclamationTriangle} /> No permission to edit funding completed
            </div>
          )}
          {hasEditPermission && (
            <ButtonTW
              type="button"
              disabled={!hasEditPermission}
              onClick={onCompleteFunding}
              data-test-id={'funding-complete-button'}
            >
              FUNDING COMPLETE
            </ButtonTW>
          )}
        </section>
      )}
      {!isLoading && fundedAt && (
        <section>
          <BodyTextTW data-test-id="funding-completed-on-text">
            Funding Completed {!!fundedBy ? 'by' : 'on'} {fundedBy}
          </BodyTextTW>
          <BodyTextTW data-test-id="funding-completed-on-date-text">
            {
              getDateString(
                DateFormat.hugeDateTime,
                `${fundedAt}Z`
              ) /** Funded at is given in UTC, Z lets the function know this also */
            }
          </BodyTextTW>
        </section>
      )}
    </div>
  );
};
